export default __webpack_public_path__ + "static/media/60.4f037d96.png";